export const LANGUAGES = [
    { code: 'af', name: 'Afrikaans', flag: '🇿🇦' },
    { code: 'sq', name: 'Shqip', flag: '🇦🇱' },
    { code: 'ar', name: 'العربية', flag: '🇩🇿' },
    { code: 'hy', name: 'Հայերեն', flag: '🇦🇲' },
    { code: 'az', name: 'Azərbaycan', flag: '🇦🇿' },
    { code: 'eu', name: 'Euskera', flag: '🇦🇩' },
    { code: 'be', name: 'Беларуская', flag: '🇧🇾' },
    { code: 'bn', name: 'বাংলা', flag: '🇧🇩' },
    { code: 'bs', name: 'Bosanski', flag: '🇧🇦' },
    { code: 'bg', name: 'Български', flag: '🇧🇬' },
    { code: 'my', name: 'မြန်မာ', flag: '🇲🇲' },
    { code: 'ca', name: 'Català', flag: '🇦🇩' },
    { code: 'zh', name: '中文', flag: '🇨🇳' },
    { code: 'hr', name: 'Hrvatski', flag: '🇭🇷' },
    { code: 'cs', name: 'Čeština', flag: '🇨🇿' },
    { code: 'da', name: 'Dansk', flag: '🇩🇰' },
    { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'et', name: 'Eesti', flag: '🇪🇪' },
    { code: 'fi', name: 'Suomi', flag: '🇫🇮' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'ka', name: 'ქართული', flag: '🇬🇪' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'el', name: 'Ελληνικά', flag: '🇬🇷' },
    { code: 'gu', name: 'ગુજરાતી', flag: '🇮🇳' },
    { code: 'ht', name: 'Kreyòl Ayisyen', flag: '🇭🇹' },
    { code: 'he', name: 'עברית', flag: '🇮🇱' },
    { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
    { code: 'hu', name: 'Magyar', flag: '🇭🇺' },
    { code: 'is', name: 'Íslenska', flag: '🇮🇸' },
    { code: 'id', name: 'Bahasa Indonesia', flag: '🇮🇩' },
    { code: 'ga', name: 'Gaeilge', flag: '🇮🇪' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'ja', name: '日本語', flag: '🇯🇵' },
    { code: 'kn', name: 'ಕನ್ನಡ', flag: '🇮🇳' },
    { code: 'kk', name: 'Қазақша', flag: '🇰🇿' },
    { code: 'km', name: 'ភាសាខ្មែរ', flag: '🇰🇭' },
    { code: 'ko', name: '한국어', flag: '🇰🇷' },
    { code: 'ku', name: 'Kurdî', flag: '🇰🇼' },
    { code: 'ky', name: 'Кыргызча', flag: '🇰🇬' },
    { code: 'lo', name: 'ລາວ', flag: '🇱🇦' },
    { code: 'lv', name: 'Latviešu', flag: '🇱🇻' },
    { code: 'lt', name: 'Lietuvių', flag: '🇱🇹' },
    { code: 'lb', name: 'Lëtzebuergesch', flag: '🇱🇺' },
    { code: 'mk', name: 'Македонски', flag: '🇲🇰' },
    { code: 'mg', name: 'Malagasy', flag: '🇲🇬' },
    { code: 'ms', name: 'Bahasa Melayu', flag: '🇲🇾' },
    { code: 'ml', name: 'മലയാളം', flag: '🇮🇳' },
    { code: 'mt', name: 'Malti', flag: '🇲🇹' },
    { code: 'mr', name: 'मराठी', flag: '🇮🇳' },
    { code: 'mn', name: 'Монгол', flag: '🇲🇳' },
    { code: 'ne', name: 'नेपाली', flag: '🇳🇵' },
    { code: 'no', name: 'Norsk', flag: '🇳🇴' },
    { code: 'ps', name: 'پښتو', flag: '🇦🇫' },
    { code: 'fa', name: 'فارسی', flag: '🇮🇷' },
    { code: 'pl', name: 'Polski', flag: '🇵🇱' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
    { code: 'pa', name: 'ਪੰਜਾਬੀ', flag: '🇮🇳' },
    { code: 'ro', name: 'Română', flag: '🇷🇴' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'sr', name: 'Српски', flag: '🇷🇸' },
    { code: 'si', name: 'සිංහල', flag: '🇱🇰' },
    { code: 'sk', name: 'Slovenčina', flag: '🇸🇰' },
    { code: 'sl', name: 'Slovenščina', flag: '🇸🇮' },
    { code: 'so', name: 'Soomaali', flag: '🇸🇴' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'sw', name: 'Kiswahili', flag: '🇹🇿' },
    { code: 'sv', name: 'Svenska', flag: '🇸🇪' },
    { code: 'tg', name: 'Тоҷикӣ', flag: '🇹🇯' },
    { code: 'ta', name: 'தமிழ்', flag: '🇮🇳' },
    { code: 'te', name: 'తెలుగు', flag: '🇮🇳' },
    { code: 'th', name: 'ไทย', flag: '🇹🇭' },
    { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
    { code: 'tk', name: 'Türkmen', flag: '🇹🇲' },
    { code: 'uk', name: 'Українська', flag: '🇺🇦' },
    { code: 'ur', name: 'اردو', flag: '🇵🇰' },
    { code: 'uz', name: 'O\'zbek', flag: '🇺🇿' },
    { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
    { code: 'cy', name: 'Cymraeg', flag: '🏴󠁧󠁢󠁷󠁬󠁳󠁿' },
    { code: 'am', name: 'አማርኛ', flag: '🇪🇹' },
    { code: 'ha', name: 'Hausa', flag: '🇳🇬' },
    { code: 'ig', name: 'Igbo', flag: '🇳🇬' },
    { code: 'yo', name: 'Yorùbá', flag: '🇳🇬' },
    { code: 'zu', name: 'isiZulu', flag: '🇿🇦' },
    { code: 'xh', name: 'isiXhosa', flag: '🇿🇦' },
    { code: 'rw', name: 'Kinyarwanda', flag: '🇷🇼' },
    { code: 'lg', name: 'Luganda', flag: '🇺🇬' },
    { code: 'ny', name: 'Chichewa', flag: '🇲🇼' },
    { code: 'st', name: 'Sesotho', flag: '🇱🇸' },
    { code: 'sn', name: 'ChiShona', flag: '🇿🇼' },
    { code: 'ti', name: 'ትግርኛ', flag: '🇪🇷' },
    { code: 'ar-sa', name: 'العربية السعودية', flag: '🇸🇦' },
    { code: 'ar-ae', name: 'العربية الإماراتية', flag: '🇦🇪' },
    { code: 'ar-qa', name: 'العربية القطرية', flag: '🇶🇦' },
    { code: 'ar-kw', name: 'العربية الكويتية', flag: '🇰🇼' },
    { code: 'ar-bh', name: 'العربية البحرينية', flag: '🇧🇭' },
    { code: 'ar-om', name: 'العربية العمانية', flag: '🇴🇲' },
    { code: 'ar-jo', name: 'العربية الأردنية', flag: '🇯🇴' },
    { code: 'ar-lb', name: 'العربية اللبنانية', flag: '🇱🇧' },
    { code: 'ar-sy', name: 'العربية السورية', flag: '🇸🇾' },
    { code: 'ar-iq', name: 'العربية العراقية', flag: '🇮🇶' },
    { code: 'ar-ly', name: 'العربية الليبية', flag: '🇱🇾' },
    { code: 'ar-tn', name: 'العربية التونسية', flag: '🇹🇳' },
    { code: 'ar-ma', name: 'العربية المغربية', flag: '🇲🇦' },
    { code: 'ar-eg', name: 'العربية المصرية', flag: '🇪🇬' },
    { code: 'ar-sd', name: 'العربية السودانية', flag: '🇸🇩' },
    { code: 'ar-ye', name: 'العربية اليمنية', flag: '🇾🇪' },
    { code: 'dv', name: 'ދިވެހި', flag: '🇲🇻' },
    { code: 'dz', name: 'རྫོང་ཁ', flag: '🇧🇹' },
    { code: 'fj', name: 'Na Vosa Vakaviti', flag: '🇫🇯' },
    { code: 'haw', name: 'ʻŌlelo Hawaiʻi', flag: '🇺🇸' },
    { code: 'mi', name: 'Te Reo Māori', flag: '🇳🇿' },
    { code: 'sm', name: 'Gagana Samoa', flag: '🇼🇸' },
    { code: 'to', name: 'Lea Fakatonga', flag: '🇹🇴' },
    { code: 'ty', name: 'Reo Tahiti', flag: '🇵🇫' },
    { code: 'qu', name: 'Runa Simi', flag: '🇵🇪' },
    { code: 'gn', name: 'Avañe\'ẽ', flag: '🇵🇾' },
    { code: 'ay', name: 'Aymar Aru', flag: '🇧🇴' },
    { code: 'eu-es', name: 'Euskera', flag: '🇪🇸' },
    { code: 'gl', name: 'Galego', flag: '🇪🇸' },
    { code: 'br', name: 'Brezhoneg', flag: '🇫🇷' },
    { code: 'co', name: 'Corsu', flag: '🇫🇷' },
    { code: 'sc', name: 'Sardu', flag: '🇮🇹' },
    { code: 'rm', name: 'Rumantsch', flag: '🇨🇭' },
    { code: 'fo', name: 'Føroyskt', flag: '🇫🇴' },
    { code: 'kl', name: 'Kalaallisut', flag: '🇬🇱' },
    { code: 'se', name: 'Davvisámegiella', flag: '🇳🇴' },
    { code: 'ceb', name: 'Sinugboanon', flag: '🇵🇭' },
    { code: 'tl', name: 'Filipino', flag: '🇵🇭' },
    { code: 'hil', name: 'Hiligaynon', flag: '🇵🇭' },
    { code: 'war', name: 'Winaray', flag: '🇵🇭' },
    { code: 'bcl', name: 'Bikol', flag: '🇵🇭' },
    { code: 'pam', name: 'Kapampangan', flag: '🇵🇭' },
    { code: 'jv', name: 'Basa Jawa', flag: '🇮🇩' },
    { code: 'su', name: 'Basa Sunda', flag: '🇮🇩' },
    { code: 'mad', name: 'Basa Madhura', flag: '🇮🇩' },
    { code: 'min', name: 'Baso Minangkabau', flag: '🇮🇩' },
    { code: 'bug', name: 'Basa Ugi', flag: '🇮🇩' },
    { code: 'ban', name: 'Basa Bali', flag: '🇮🇩' },
    { code: 'ace', name: 'Bahsa Acèh', flag: '🇮🇩' },
    { code: 'bjn', name: 'Bahasa Banjar', flag: '🇮🇩' },
    { code: 'bm', name: 'Bamanankan', flag: '🇲🇱' },
    { code: 'ff', name: 'Fulfulde', flag: '🇸🇳' },
    { code: 'wo', name: 'Wolof', flag: '🇸🇳' },
    { code: 'ln', name: 'Lingála', flag: '🇨🇩' },
    { code: 'kg', name: 'Kikongo', flag: '🇨🇩' },
    { code: 'sw-ke', name: 'Kiswahili Kenya', flag: '🇰🇪' },
    { code: 'sw-tz', name: 'Kiswahili Tanzania', flag: '🇹🇿' },
    { code: 'ak', name: 'Akan', flag: '🇬🇭' },
    { code: 'tw', name: 'Twi', flag: '🇬🇭' },
    { code: 'ee', name: 'Eʋegbe', flag: '🇬🇭' },
    { code: 'gaa', name: 'Ga', flag: '🇬🇭' },
    { code: 'ug', name: 'ئۇيغۇرچە', flag: '🇨🇳' },
    { code: 'tt', name: 'Татарча', flag: '🇷🇺' },
    { code: 'ba', name: 'Башҡортса', flag: '🇷🇺' },
    { code: 'cv', name: 'Чӑвашла', flag: '🇷🇺' },
    { code: 'sah', name: 'Саха тыла', flag: '🇷🇺' },
    { code: 'os', name: 'Ирон ӕвзаг', flag: '🇷🇺' },
    { code: 'ce', name: 'Нохчийн мотт', flag: '🇷🇺' },
    { code: 'av', name: 'Авар мацӀ', flag: '🇷🇺' },
    { code: 'lez', name: 'Лезги чӀал', flag: '🇷🇺' },
    { code: 'pap', name: 'Papiamentu', flag: '🇦🇼' },
    { code: 'gcf', name: 'Kréyòl Gwadloup', flag: '🇬🇵' },
    { code: 'mfe', name: 'Kreol Morisien', flag: '🇲🇺' },
    { code: 'bislama', name: 'Bislama', flag: '🇻🇺' },
    { code: 'tpi', name: 'Tok Pisin', flag: '🇵🇬' },
    { code: 'ho', name: 'Hiri Motu', flag: '🇵🇬' },
    { code: 'as', name: 'অসমীয়া', flag: '🇮🇳' },
    { code: 'bho', name: 'भोजपुरी', flag: '🇮🇳' },
    { code: 'brx', name: 'बर\'', flag: '🇮🇳' },
    { code: 'doi', name: 'डोगरी', flag: '🇮🇳' },
    { code: 'gom', name: 'कोंकणी', flag: '🇮🇳' },
    { code: 'mai', name: 'मैथिली', flag: '🇮🇳' },
    { code: 'mni', name: 'মৈতৈ', flag: '🇮🇳' },
    { code: 'sat', name: 'ᱥᱟᱱᱛᱟᱲᱤ', flag: '🇮🇳' },
    { code: 'sd', name: 'سنڌي', flag: '🇵🇰' },
    { code: 'ks', name: 'کٲشُر', flag: '🇮🇳' },
    { code: 'hmn', name: 'Hmoob', flag: '🇱🇦' },
    { code: 'lao', name: 'ພາສາລາວ', flag: '🇱🇦' },
    { code: 'bo', name: 'བོད་སྐད་', flag: '🇨🇳' },
    { code: 'ii', name: 'ꆈꌠꉙ', flag: '🇨🇳' },
    { code: 'za', name: 'Saw cuengh', flag: '🇨🇳' }
];
